module.exports = __webpack_public_path__ + "static/img/desplazamientos-1.6114bab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/desplazamientos-1.jpg
// module id = p4Zp
// module chunks = 1